import { observer } from "mobx-react";
import { h } from "preact";
import { makeImgUrl, setQueryParams } from "../utils/URL";
import { translate, t, } from "restaumatic-client";
import ShowMore from "./ShowMore";
import NumericStepper, { NumericStepperButton } from "./NumericStepper";
import AllergensPopover from "./AllergensPopover";
const IMAGE_PARAMS = {
    auto: "compress",
    crop: "focalpoint",
    fit: "crop",
    "max-h": "200",
    "max-w": "400",
};
const PLACEHOLDER_IMAGE_URN = "/uploads/media_library/3759b3df5982ce78756f289321cb79d3.png";
function CrossSellingItem(props) {
    var _a, _b, _c;
    const { item, className = "", openProductCard } = props;
    const isTabletOrDesktop = (_a = Skubacz.Device.screen.isSmallMin()) !== null && _a !== void 0 ? _a : false;
    const imageUrn = isTabletOrDesktop
        ? (_b = item.image) !== null && _b !== void 0 ? _b : PLACEHOLDER_IMAGE_URN
        : (_c = item.image) !== null && _c !== void 0 ? _c : null;
    const hasImage = imageUrn !== null;
    const hasAllergens = item.allergens.length > 0;
    return (h("article", { class: `m-crossup__item ${className}` },
        h("div", { class: `m-crossup__item-content ${item.behaviour.isActive ? "is-active" : ""}` },
            hasImage && (h(CrossSellingImage, { imageUrn: imageUrn, alt: "", onClick: openProductCard === null || openProductCard === void 0 ? void 0 : openProductCard.bind(null, item.productInstance) })),
            h("div", { class: "d-flex flex-column u-flex-grow" },
                h("h4", { class: "u-my0 u-font-size-inherit" },
                    h("span", { class: "m-crossup__item-title" }, item.name),
                    " ",
                    hasAllergens && h(AllergensPopover, { allergens: item.allergens })),
                h(ShowMore, { containerClass: "u-mb4", textClass: "m-crossup__item-desc" }, item.description),
                h("footer", { class: "d-flex justify-content-between align-items-center" },
                    h("div", { class: "m-crossup__price" }, item.price),
                    h(CrossSellingItemCounter, { behaviour: item.behaviour }))))));
}
const CrossSellingImage = observer((params) => {
    const { imageUrn, alt, onClick } = params;
    const imageSrc = setQueryParams(IMAGE_PARAMS, makeImgUrl(imageUrn));
    const isClickable = Boolean(onClick);
    return (h("button", { type: "button", onClick: onClick, disabled: !isClickable, "aria-label": `${translate(t.restaurants.menu.show)} ${alt}`, class: `m-crossup__item-picture u-btn-unstyled ${isClickable ? "" : "u-cursor-default"}` },
        h("picture", null,
            h("img", { class: "m-crossup__item-img", loading: "lazy", src: imageSrc, alt: alt }))));
});
const CrossSellingItemCounter = observer(({ behaviour }) => {
    const size = "large";
    const addLabel = translate(t.restaurants.menu.add);
    const addClass = "m-crossup__counter-btn--add";
    switch (behaviour.type) {
        case "Cart":
            return (h(NumericStepperButton, { type: "increment", onClick: () => behaviour.add(), ariaLabel: addLabel, className: addClass, size: size }));
        case "ProductCard":
            return (h(NumericStepper, { type: "dynamic", quantity: behaviour.quantity, canDecrement: behaviour.canDecrement, onDecrement: () => behaviour.decrement(), decrementAriaLabel: translate(t.restaurants.menu.remove), onIncrement: () => behaviour.increment(), incrementAriaLabel: addLabel, incrementClass: addClass, size: size }));
    }
});
export default observer(CrossSellingItem);
